import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import HomeIcon from "@mui/icons-material/Home";
import TuneIcon from "@mui/icons-material/Tune";

export const mainNavbarItems = [
  {
    icon: <HomeIcon />,
    label: "Home",
    route: "/",
  },
  {
    icon: <AssignmentTurnedInIcon />,
    label: "Accetta",
    route: "/documents?type=ACCEPTANCE&status=OPEN",
  },
  {
    icon: <LocalShippingIcon />,
    label: "Evadi",
    route: "/documents?type=DISPATCH&status=OPEN",
  },
  {
    icon: <TuneIcon />,
    label: "Gestisci",
    route: "/verify",
  },
];
